/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExtendedDashboardOut } from '../models/ExtendedDashboardOut';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DashboardService {
  /**
   * Full Dashboard
   * @returns ExtendedDashboardOut Successful Response
   * @throws ApiError
   */
  public static extendedDashboard(): CancelablePromise<ExtendedDashboardOut> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/extended-dashboard',
    });
  }
}
